import {EventEmitter, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs/index';
import {ApprovalModel} from '../dto/approval.model';
import {ApprovalPending} from '../dto/approval-pending';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ReversedSuspendService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/searchRequestData', data);
  }

  searchReversedRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/searchRequestDataRevased', data);
  }

  getAllRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/getRequestData', data);
  }

  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/getReturnRequest', data);
  }

  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/getDGReturnRequest', data);
  }

  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/searchPendingRequests', data);
  }

  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'revered-suspend/getApplicantDetails/'+ applicationId);
  }

  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/approveRequest', approvalModel, {headers: this.headers});
  }

  getPendingVerificationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-suspend/getPendingRequests',approvalModel,{headers: this.headers});
  }


  getPendingAuthorizationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-suspend/getPendingAuthList',approvalModel,{headers: this.headers});
  }

  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend/returnRequest', approvalModel, {headers: this.headers});
  }


  saveDocumentTypeAndDetails(details) {
    return this.httpClient.post<any>(this.baseUrl + 'revered-suspend/saveDocumentDetails', details);
  }

}
